import { IAccountImpact } from 'src/types'

import { List } from './account-impacts.styled'
import { forwardRef } from 'react'
import { AccountImpactItem } from './account-impacts-item'

interface IProps {
  items: IAccountImpact[]
  withArrows?: boolean
  walletAddress?: string
  showWalletAddress: boolean
  showBcInfo: boolean
  accountImage?: string
  bannerStroke: string
}

export const AccountImpactsList = forwardRef<HTMLDivElement, IProps>(
  (
    { items, withArrows, walletAddress, showWalletAddress, showBcInfo, accountImage, bannerStroke },
    ref,
  ) => {
    return (
      <List
        id="account-impacts-list__components-account-impacts__list__l14"
        ref={ref}
        withArrows={withArrows}
      >
        {items.map((item) => (
          <AccountImpactItem
            key={item.id}
            title={item.quantity}
            quantityName={item.quantity_type_name || item.custom_quantity_type}
            subtitle={item.name}
            image={item.image_medium || item.image}
            unSdg={item.un_sdg}
            item={item}
            walletAddress={walletAddress}
            showWalletAddress={showWalletAddress}
            showBcInfo={showBcInfo}
            accountImage={accountImage}
            bannerStroke={bannerStroke}
          />
        ))}
      </List>
    )
  },
)
